import React, { Component } from 'react';
import './Home.css';
import TitleBar from '../components/TitleBar/TitleBar';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; 

import apple_store from '../images/applestore.svg';
import google_play from '../images/googlestore.svg';
import apk_store from '../images/apkstore.svg';
import epoch_landing from '../images/epoch_landing.png';
import epoch_landing1 from '../images/epoch_landing1.png';
import epoch_landing2 from '../images/epoch_landing2.png';
import feature_sing_icon from '../images/illustration_sing.svg';
import feature_guitar_icon from '../images/illustration_guitar.svg';
import feature_statistic_icon from '../images/illustration_statistic.png';
import feature_goal_icon from '../images/illustration_goal.png';
import twitter_icon from '../images/twitter_circled.svg';
import product_hunt_icon from '../images/product-hunt-logo.svg';
import github_icon from '../images/github_icon.svg';
import email_icon from '../images/email_circled.svg';


class Home extends Component {
  render() {
    return (
      <div className='home'>
        <TitleBar/>
        <div className='homeContainer'>
          <div className='welcomeTitle'>Welcome to Epoch Tuner</div>
          <div className='welcomeSubtitle'>Copilot for Guitar Player</div>
          <div style={{color: 'gray', fontSize: 22, marginTop: 10 }}>The Best Guitar Tuner on your mobile phones</div>

          <a href='#download' className='downloadButtonStyle' style={{marginTop: 40, marginBottom: 60}}>Get Started</a>
          <div style={{maxWidth: 880}}>
            <Carousel autoPlay={true} showThumbs={false} infiniteLoop={true} showArrows={false} className='carousel'>
              <div>
                <img src={epoch_landing} alt="epoch" style={{objectFit: 'contain', borderRadius: 16, maxWidth: 960}}/>
              </div>
              <div>
                <img src={epoch_landing1} alt="epoch" style={{objectFit: 'contain', borderRadius: 16, maxWidth: 960}}/>
              </div>
              <div>
                <img src={epoch_landing2} alt="epoch" style={{objectFit: 'contain', borderRadius: 16, maxWidth: 960}}/>
              </div>
            </Carousel>
          </div>
          <div id='features' style={{height: 100}}/>
          <div style={{fontSize: 36, fontWeight: '650', color: '#fff'}}>Features to help you become a guitar master</div>
          <div style={{color: '#ffffffaa', fontSize: 24, marginBottom: 40, marginTop: 10 }}>Practice guitar for 10,000 hours</div>

          <div className='featureItem'>
            <div className='featureImageContainer'>
              <img src={feature_sing_icon} alt="epoch" className='featureImage'/>
            </div>
            <div>
              <div style={{fontSize: 28, fontWeight: '600', color: '#fff'}}>Pitch Detector and 88 piano notes</div>
              <div style={{color: '#ffffffaa', fontSize: 20}}>Epoch Tuner can detect the pitch of the sound and show you the note name. It's easy to detect the pitch of any sound</div>
            </div>
          </div>
          <div className='featureItem'>
            <div className='featureImageContainer'>
              <img src={feature_guitar_icon} alt="epoch" className='featureImage'/>
            </div>
            <div>
              <div style={{fontSize: 28, fontWeight: '600', color: '#fff'}}>Custom Tuning for Guitar , Ukulele, Bass</div>
              <div style={{color: '#ffffffaa', fontSize: 20}}>You can use many popular tunings preset in Epoch and even create your own tuning, It's very useful for FingerStyle</div>
            </div>
          </div>
          <div className='featureItem'>
            <div className='featureImageContainer'>
              <img src={feature_statistic_icon} alt="epoch" className='featureImage'/>
            </div>
            <div>
              <div style={{fontSize: 28, fontWeight: '600', color: '#fff'}}>Guitar Practice Statistics</div>
              <div style={{color: '#ffffffaa', fontSize: 20}}>Record  your practice data and visualize it to help you understand your habits</div>
            </div>
          </div>
          <div className='featureItem'>
            <div className='featureImageContainer'>
              <img src={feature_goal_icon} alt="epoch" className='featureImage'/>
            </div>
            <div>
              <div style={{fontSize: 28, fontWeight: '600', color: '#fff'}}>Set Goal and Reminder</div>
              <div style={{color: '#ffffffaa', fontSize: 20}}>You can set practice goal and reminder, Epoch will remind you  at given time</div>
            </div>
          </div>
          <div className='bottomSection'>
            <div id='download' style={{fontSize: 36, fontWeight: '600', color: '#fff', marginTop: 100}}>Download App from</div>
            <div style={{display: 'flow', marginTop: 20}}>
              <a href="https://apps.apple.com/cn/app/epoch-music-toolkit/id1459345397" style={{marginRight: 4}} target="blank">
                <img src={apple_store} alt="apple_store"/>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.rego.epoch" style={{marginRight: 4}} target="blank">
                <img src={google_play} alt="google_play"/>
              </a>
              <a href="https://www.pgyer.com/epochpro" style={{marginRight: 4}} target="blank">
                <img src={apk_store} alt="google_play"/>
              </a>
            </div>
            <div id='supports' style={{fontSize: 36, fontWeight: '600', color: '#fff', marginTop: 100}}>Supports</div>
            <div className="tagContainer">
              <a target="blank" href="https://twitter.com/panlei106">
                <img src={twitter_icon} alt="twitter_icon" style={{width: 32, marginRight: 16}}/>
              </a>
              <a target="blank" href="https://github.com/Panl">
                <img src={github_icon} alt="github_icon" style={{width: 32, marginRight: 16}}/>
              </a>
              <a target="blank" href="https://www.producthunt.com/products/epoch-3#epoch-4">
                <img src={product_hunt_icon} alt="github_icon" style={{width: 32, marginRight: 16}}/>
              </a>
              <a href="mailto:main@epochpro.app?subject=Feedback from web&body=">
                <img src={email_icon} alt="email_icon" style={{width: 32}}/>
              </a>
            </div>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <div style={{color: '#ffffffcc', fontSize: 16, margin: 20}}>© 2023 Epoch Tuner App. All rights reserved.</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default Home